export default "https://assets.egbcdn.net/assets/packs/_/images/promo_action/instructions/image5-65d42a8b44cddb72b259f23404328c60.png";